import { api, saveBlob } from './client';
import { endpoints } from './endpoints';

/**
 * Reporting for all three audiences.
 *
 * Trend calls use `getPaginated` rather than `get` because the bucket width
 * arrives in `meta` and the chart needs it to label its own axis.
 */
export function getCompanyOverview(days) {
  return api.get(endpoints.companies.analyticsOverview, { params: { days } });
}

export function getCompanyTrends(days) {
  return api.getPaginated(endpoints.companies.analyticsTrends, { params: { days } });
}

export function getInternshipPerformance(params) {
  return api.getPaginated(endpoints.companies.analytics, { params });
}

/**
 * One listing's report. Gated on `internship.read` rather than
 * `analytics.read`, so a recruiter can see how the posting they run is doing.
 */
export function getListingPerformance(id, days) {
  return api.get(endpoints.companies.internshipPerformance(id), { params: { days } });
}

export function getCandidateInsights(days) {
  return api.get(endpoints.companies.analyticsCandidates, { params: { days } });
}

export function getOutcomes(days) {
  return api.get(endpoints.companies.analyticsOutcomes, { params: { days } });
}

export function getStudentInsights(days) {
  return api.get(endpoints.students.analytics, { params: { days } });
}

export function getPlatformOverview(days) {
  return api.get(endpoints.admin.analyticsOverview, { params: { days } });
}

export function getPlatformGrowth(days) {
  return api.getPaginated(endpoints.admin.analyticsGrowth, { params: { days } });
}

export function getPlatformSegments(days) {
  return api.get(endpoints.admin.analyticsSegments, { params: { days } });
}

// -- running the platform ----------------------------------------------------
// Five reports that answer what the funnel does not: what the platform earns,
// whether moderation is keeping up, and whether the match score means
// anything. All admin-only, all read-only.
export function getRevenueReport(days) {
  return api.get(endpoints.admin.analyticsRevenue, { params: { days } });
}

export function getSubscriptionReport(days) {
  return api.get(endpoints.admin.analyticsSubscriptions, { params: { days } });
}

export function getVerificationReport(days) {
  return api.get(endpoints.admin.analyticsVerification, { params: { days } });
}

export function getListingReport(days) {
  return api.get(endpoints.admin.analyticsListings, { params: { days } });
}

export function getAiReport(days) {
  return api.get(endpoints.admin.analyticsAi, { params: { days } });
}

/**
 * Download one report table as CSV and hand it to the browser.
 *
 * `sheet` names the table, not the report: a report on screen is a headline, a
 * chart and two tables, and a CSV that tried to be all three at once opens in
 * Excel as something no formula can address.
 */
export async function exportReport(sheet, days) {
  const { blob, filename } = await api.download(endpoints.admin.analyticsExport, {
    params: { sheet, days },
  });
  saveBlob(blob, filename);
  return filename;
}
